// src/components/BrandsSection.js
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import "./BrandsSection.css";

/* ---------- Ortak ayarlar ---------- */
const baseUrl = "https://apiportal.mbsays.com/public/api";
const token = sessionStorage.getItem("authToken") || "admin_token";
const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
const isAdmin =
  storedUser?.role === "admin" || storedUser?.is_admin === 1;

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
};

const BrandsSection = () => {
  /* ---------- State ---------- */
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  /* Modal + Form */
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentBrand, setCurrentBrand] = useState(null);
  const [modalEditMode, setModalEditMode] = useState(false);
  const [isCreatingBrand, setIsCreatingBrand] = useState(false);

  /* ---------- API ---------- */
  const fetchBrands = async () => {
    try {
      const res = await fetch(`${baseUrl}/brands`, { headers });
      const data = await res.json();
      setBrands(data);
    } catch (e) {
      console.error("Markalar çekilirken hata:", e);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchBrands();
      setLoading(false);
    })();
  }, []);

  /* ---------- Modal ---------- */
  const openDetails = (brand) => {
    setCurrentBrand(brand);
    setModalEditMode(false);
    setIsCreatingBrand(false);
    setModalIsOpen(true);
  };

  const openCreateBrandModal = () => {
    if (!isAdmin) return;
    setIsCreatingBrand(true);
    setCurrentBrand({
      logo: "",
      name: "",
      description: "",
      sort: "",
      status: true,
    });
    setModalEditMode(true);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setCurrentBrand(null);
    setModalEditMode(false);
    setIsCreatingBrand(false);
    setModalIsOpen(false);
  };

  /* ---------- Form değişimleri ---------- */
  const handleBrandChange = ({ target: { name, value, type, checked } }) =>
    setCurrentBrand((p) => ({
      ...p,
      [name]: type === "checkbox" ? checked : value,
    }));

  /* ---------- Oluştur / Güncelle ---------- */
  const handleBrandSubmit = async (e) => {
    e.preventDefault();
    if (!isAdmin) return;

    try {
      const payload = {
        logo: currentBrand.logo,
        name: currentBrand.name,
        description: currentBrand.description,
        sort: Number(currentBrand.sort),
        status: currentBrand.status,
      };

      await fetch(
        `${baseUrl}/brands${isCreatingBrand ? "" : `/${currentBrand.id}`}`,
        {
          method: isCreatingBrand ? "POST" : "PUT",
          headers,
          body: JSON.stringify(payload),
        }
      );

      await fetchBrands();
      closeModal();
    } catch (e) {
      console.error("Marka kaydı sırasında hata:", e);
    }
  };

  /* ---------- Sil ---------- */
  const handleDeleteBrand = async (id) => {
    if (!isAdmin) return;
    if (!window.confirm("Markayı silmek istediğinize emin misiniz?")) return;

    try {
      await fetch(`${baseUrl}/brands/${id}`, {
        method: "DELETE",
        headers,
      });
      await fetchBrands();
      closeModal();
    } catch (e) {
      console.error("Silme hatası:", e);
    }
  };

  /* ---------- UI ---------- */
  if (loading)
    return (
      <div className="loading-container">
        <div className="spinner" />
        <p>Yükleniyor…</p>
      </div>
    );

  return (
    <div className="brands-section">
      <h2>Brand Management</h2>

      <section className="brand-management">
        <h3>Marka Yönetimi</h3>

        {isAdmin && (
          <button className="create-brand-button" onClick={openCreateBrandModal}>
            Yeni Marka Ekle
          </button>
        )}

        <div className="brands-list">
          {brands.map((b) => (
            <div
              key={b.id}
              className="brand-card"
              onClick={() => openDetails(b)}
            >
              <img src={b.logo} alt={b.name} className="brand-logo" />
              <h4>{b.name}</h4>
              <p>{b.description}</p>
              <p>
                <strong>Sıra:</strong> {b.sort}
              </p>
              <p>
                <strong>Durum:</strong> {b.status ? "Aktif" : "Pasif"}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ---------- Modal ---------- */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Marka Detayları"
        className="modal"
        overlayClassName="modal-overlay"
      >
        {currentBrand && !modalEditMode && (
          <div className="brand-details">
            <img
              src={currentBrand.logo}
              alt={currentBrand.name}
              className="brand-logo-large"
            />
            <h2>{currentBrand.name} Detayları</h2>
            <p>
              <strong>Açıklama:</strong> {currentBrand.description}
            </p>
            <p>
              <strong>Sıra:</strong> {currentBrand.sort}
            </p>
            <p>
              <strong>Durum:</strong> {currentBrand.status ? "Aktif" : "Pasif"}
            </p>

            <div className="modal-buttons">
              {isAdmin && (
                <>
                  <button
                    className="edit-button"
                    onClick={() => setModalEditMode(true)}
                  >
                    Düzenle
                  </button>
                  <button
                    className="delete-button"
                    onClick={() => handleDeleteBrand(currentBrand.id)}
                  >
                    Sil
                  </button>
                </>
              )}
              <button className="modal-close" onClick={closeModal}>
                x
              </button>
            </div>
          </div>
        )}

        {currentBrand && modalEditMode && isAdmin && (
          <div className="update-form-container">
            <h2>
              {isCreatingBrand
                ? "Yeni Marka Ekle"
                : `${currentBrand.name} Bilgilerini Güncelle`}
            </h2>

            <form onSubmit={handleBrandSubmit} className="update-form">
              {isCreatingBrand && (
                <div className="form-group">
                  <label>Logo URL:</label>
                  <input
                    type="url"
                    name="logo"
                    value={currentBrand.logo}
                    onChange={handleBrandChange}
                    required
                    placeholder="https://example.com/logo.png"
                  />
                </div>
              )}

              <div className="form-group">
                <label>Marka Adı:</label>
                <input
                  type="text"
                  name="name"
                  value={currentBrand.name}
                  onChange={handleBrandChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Açıklama:</label>
                <textarea
                  name="description"
                  value={currentBrand.description}
                  onChange={handleBrandChange}
                  required
                />
              </div>

              {/* ---- Sıralama alanı artık düzenlemede de görünür ---- */}
              <div className="form-group">
                <label>Sıra:</label>
                <input
                  type="number"
                  name="sort"
                  value={currentBrand.sort}
                  onChange={handleBrandChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Durum:</label>
                <input
                  type="checkbox"
                  name="status"
                  checked={currentBrand.status}
                  onChange={handleBrandChange}
                />{" "}
                Aktif
              </div>

              <div className="modal-buttons">
                <button type="submit" className="submit-button">
                  {isCreatingBrand ? "Oluştur" : "Güncelle"}
                </button>
                <button className="close-button" onClick={closeModal}>
                  İptal
                </button>
              </div>
            </form>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default BrandsSection;
